/**
 * Header Layout
 *
 * @file header.js
 */


const header = (() => {
  const headerSearch = () => {
    const searchInput = document.querySelector('.header-search-box input');
    const fullSearchContainer = document.querySelector('.full-search-container');
    const headerDropShadow = document.querySelector('.header-backdrop-shadow');

    document.querySelector('.header-search').addEventListener('click', function() {
      // this.classList.add("hide");
      document.querySelector('.header-search-box').classList.add('search-active');
      document.body.classList.add('hidden');
      window.dispatchEvent(new Event('resize'));
    });
    document.querySelector('.mobile-search').addEventListener('click', function() {
      // this.classList.add("hide");
      document.querySelector('.header-search-box').classList.add('search-active');
      document.body.classList.add('hidden');
    });
    document.querySelector('.header-search-box button').addEventListener('click', function() {
      document.querySelector('.header-search-box').classList.remove('search-active');
      // document.querySelector('.header-search').classList.remove("hide");
      document.querySelector('.header-search-box input').value = '';
      headerDropShadow.classList.remove('active');
      fullSearchContainer.classList.remove('active');
      document.body.classList.remove('hidden');
    });

    searchInput.addEventListener('input', function() {
        if (searchInput.value.length >= 3) {
            fullSearchContainer.classList.add('active');
            headerDropShadow.classList.add('active');
        } else {
            fullSearchContainer.classList.remove('active');
            headerDropShadow.classList.remove('active');
        }
    });
  };

  const headerMenu = () => {
    const menuItems = document.querySelectorAll('.header-mx-menu .main-nav ul > li');
    const backdrop = document.querySelector('.header-backdrop-shadow');
    const mobileMenuBtn = document.querySelector('.mobile-menu');
    const mobileMenuContainer = document.querySelector('.mobile-header-menu');
    const mobileSubMenu = document.querySelectorAll('.sub-menu-sh > a');
    const mobileMenuSubPrev = document.querySelectorAll('.prev-mobile-menu');

    menuItems.forEach(function(item) {
        let timeoutId;

        item.addEventListener('mouseenter', function() {
            timeoutId = setTimeout(() => {
                backdrop.classList.add('active');
            }, 500);
        });

        item.addEventListener('mouseleave', function() {
            clearTimeout(timeoutId);
            backdrop.classList.remove('active');
        });
    });
    mobileMenuBtn.addEventListener('click', function() {
      this.classList.toggle("active");
      document.body.classList.toggle('hidden');
      mobileMenuContainer.classList.toggle("menu-open");
    });
    mobileSubMenu.forEach(function(item) {
      item.addEventListener('click', function() {
          var subMenu = this.nextElementSibling;
          mobileMenuContainer.classList.add("hide-scroll");
          if (subMenu) {
            subMenu.classList.add('show-sub-menu');
          }
      });
    });
    mobileMenuSubPrev.forEach(function(item) {
      item.addEventListener('click', function() {
          const parentSubMenu = this.closest('.sub-menu');
          if (parentSubMenu) {
              parentSubMenu.classList.remove('show-sub-menu');
          }
          mobileMenuContainer.classList.remove("hide-scroll");
      });
    });

  };

  const mobileAccountMenu = () => {
    if(document.querySelector('.mobile-prev-menu')){
      document.querySelector('.mobile-prev-menu').addEventListener('click', function(item) {
        this.classList.toggle('active');
        document.querySelector('.account-left-menu').classList.toggle('show-menu');
        document.querySelector('.account-right-content').classList.toggle('show-menu');
      });
    }
  };

  const mobileLeftDetailPagetMenu = () => {
    if(document.querySelector('.mobile-menu-selected')){
      document.querySelector('.mobile-menu-selected').addEventListener('click', function() {
        if (window.innerWidth <= 680) {
          this.classList.toggle("active");
            document.querySelector('.policies-page .left-menu nav').classList.toggle('active');
        }
    });
    }
  };

  const pageLoadingModal = () => {
    // document.addEventListener('DOMContentLoaded', function() {
    //   const pageLoader = document.querySelector('.page-loading-modal');
      
    //   // Sayfa yüklendiğinde
    //   window.addEventListener('load', () => {
    //       setTimeout(() => {
    //           pageLoader.style.opacity = '0';
    //           setTimeout(() => {
    //               pageLoader.style.display = 'none';
    //           }, 300);
    //       }, 500);
    //   });
  
    //   // Sayfa geçişlerinde
    //   document.addEventListener('click', (e) => {
    //       const link = e.target.closest('a');
          
    //       if (link && !link.target && !link.hasAttribute('download') && !link.classList.contains('no-loader')) {
    //           e.preventDefault();
    //           pageLoader.style.display = 'flex';
    //           pageLoader.style.opacity = '1';
              
    //           setTimeout(() => {
    //               window.location.href = link.href;
    //           }, 300);
    //       }
    //   });
    // });
  };

  const init = () => {
    headerSearch();
    headerMenu();
    mobileAccountMenu();
    mobileLeftDetailPagetMenu();
    pageLoadingModal();
  };

  return {
    init,
  };
})();

export default header;
